import React, { FC } from 'react';
import { SC } from '../../styles/theme';
import useTranslations from '@hooks/useTranslations';
import { useGetNotEscapedTranslationMarkup } from '@hooks/useGetNotEscapedTranslationMarkup';

interface SummaryLegalTextProps extends SC {}

const SummaryLegalTextTemplate: FC<SummaryLegalTextProps> = ({ className }) => {
    const { t } = useTranslations();
    const { getNotEscapedTranslationMarkup } = useGetNotEscapedTranslationMarkup();

    return (
        <div className={className}>
            <p>
                <span dangerouslySetInnerHTML={getNotEscapedTranslationMarkup('filters.legal.text')} />
            </p>
        </div>
    );
};

export default SummaryLegalTextTemplate;
